import React from "react";
import { Box, Button, Breadcrumbs, useTheme } from "@material-ui/core";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import HomeIcon from "@material-ui/icons/Home";
import { CustomTheme } from "../../../../../../types/customTheme";

interface BreadcrumbNavProps {
  currentStack?: any[];
  selectedMenuName?: string;
  onNavigate?: (index: number) => void;
}

const BreadcrumbNav: React.FC<BreadcrumbNavProps> = ({
  currentStack = [],
  selectedMenuName = "Menu",
  onNavigate,
}) => {
  const theme: CustomTheme = useTheme();

  if (currentStack.length === 0) {
    return null;
  }

  return (
    <Box
      style={{
        padding: "12px 24px",
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Breadcrumbs
        separator={
          <NavigateNextIcon
            fontSize="small"
            style={{ color: theme.palette.custom.orange.contrastText }}
          />
        }
      >
        <Button
          size="small"
          onClick={() => onNavigate && onNavigate(-1)}
          style={{
            color: theme.palette.custom.orange.contrastText,
            textTransform: "none",
            padding: "4px 8px",
            minWidth: "auto",
          }}
        >
          <HomeIcon style={{ fontSize: "16px", marginRight: "4px" }} />
          {selectedMenuName}
        </Button>
        {currentStack.map((item, index) => (
          <Button
            key={item.id}
            size="small"
            onClick={() => onNavigate && onNavigate(index)}
            style={{
              color:
                index === currentStack.length - 1
                  ? theme.palette.custom.yellow.main
                  : theme.palette.custom.orange.contrastText,
              textTransform: "none",
              padding: "4px 8px",
              minWidth: "auto",
            }}
          >
            {item.name}
          </Button>
        ))}
      </Breadcrumbs>
    </Box>
  );
};

export default BreadcrumbNav;
